import { Routes } from "@angular/router";

export const routes: Routes = [
  {
    path: "",
    loadChildren: () => import("./home/home.routes").then((m) => m.HOME_ROUTES),
  },
  {
    path: "careers",
    loadChildren: () =>
      import("./careers/careers.routes").then((m) => m.CAREERS_ROUTES),
  },
  {
    path: "careers/:id",
    loadChildren: () =>
      import("./careers-detail/careers-detail.routes").then(
        (m) => m.CAREERS_DETAIL_ROUTES,
      ),
  },
  {
    path: "newsroom",
    loadChildren: () =>
      import("./newsroom/newsroom.routes").then((m) => m.NEWSROOM_ROUTES),
  },
  {
    path: "newsroom/:title",
    loadChildren: () =>
      import("./newsroom-detail/newsroom-detail.routes").then(
        (m) => m.NEWSROOM_DETAIL_ROUTES,
      ),
  },
  {
    path: "privacy-policy",
    loadChildren: () =>
      import("./privacy-policy/privacy-policy.routes").then(
        (m) => m.PRIVACY_POLICY_ROUTES,
      ),
  },
  {
    path: "404",
    loadChildren: () =>
      import("./error/error.routes").then((m) => m.ERROR_ROUTES),
  },
  {
    path: "**",
    loadChildren: () =>
      import("./error/error.routes").then((m) => m.ERROR_ROUTES),
  },
];
